<div class="d-flex justify-content-between align-items-center bg-secondary mt-3 w-100 text-white px-4 py-2"
    *ngIf="students.length > 0">
    <label class="fs-5 m-0"><span class="vag-bold-font">EVALUACIÓN</span> {{students[studentCurrent].fullname}}</label>
    <div class="d-flex">
        <button [disabled]="!students[studentCurrent - 1]" class="btn mx-1" (click)="decreaseIndex()">
            <fa-icon [icon]="chevronLeft" class="text-white"></fa-icon>
        </button>
        <button [disabled]="!students[studentCurrent + 1]" class="btn mx-1" (click)="increaseIndex()">
            <fa-icon [icon]="chevronRight" class="text-white"></fa-icon>
        </button>
    </div>
</div>
<div class="my-3" *ngIf="courseCurrent">
    Curso: <select (change)="chooseCourse($event)">
        <option *ngFor="let course of students[studentCurrent]?.courseInfoArr" value="{{course.id}}">
            {{course.description}}</option>
    </select> {{courseCurrent.centerDescr}} {{showCourseDays(courseCurrent)}} {{showCourseShedule(courseCurrent)}}
</div>
<div class="pt-3">
    <div class="d-flex border-bottom pb-2 border-black">
        <div class="col vag-bold-font">
            Evaluación
        </div>
        <div class="col vag-bold-font">
            Año académico
        </div>
        <div class="col vag-bold-font">
            Descarga
        </div>
    </div>
    <div *ngIf="students.length > 0 && courseCurrent">
        <div class="d-flex border-bottom pb-2 border-black mt-2">
            <div class="col">
                Sep-Dic
            </div>
            <div class="col">
                {{showSerie(courseCurrent?.serieName)}}
            </div>
            <div class="col">
                <a [ngClass]="(students[studentCurrent].authorizationTutor && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]
                 && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]['sep-dic']) ? 'is_active' : 'is_disabled'"
                    (click)="students[studentCurrent]?.authorizationTutor['course_' + this.courseCurrent.id]['sep-dic']?
                 generarEvaluation(students[studentCurrent]?.id, 'sep-dic'): null">Boletín</a>
            </div>
        </div>
        <div class="d-flex border-bottom pb-2 border-black mt-2">
            <div class="col">
                Ene-Mar
            </div>
            <div class="col">
                {{showSerie(courseCurrent?.serieName)}}
            </div>
            <div class="col">
                <a [ngClass]="(students[studentCurrent].authorizationTutor && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]
                 && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]['ene-mar']) ? 'is_active' : 'is_disabled'"
                    (click)="students[studentCurrent]?.authorizationTutor['course_' + this.courseCurrent.id]['ene-mar']?
              generarEvaluation(students[studentCurrent]?.id, 'ene-mar'): null">Boletín</a>
            </div>
        </div>
        <div class="d-flex border-bottom pb-2 border-black mt-2">
            <div class="col">
                Abr-Jun
            </div>
            <div class="col">
                {{showSerie(courseCurrent?.serieName)}}
            </div>
            <div class="col">
                <a [ngClass]="(students[studentCurrent].authorizationTutor && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]
                 && students[studentCurrent].authorizationTutor['course_' + this.courseCurrent.id]['abr-jun']) ? 'is_active' : 'is_disabled'"
                    (click)="students[studentCurrent]?.authorizationTutor['course_' + this.courseCurrent.id]['abr-jun']?
              generarEvaluation(students[studentCurrent]?.id, 'abr-jun'): null">Boletín</a>
            </div>
        </div>
        <div class="d-flex border-bottom pb-2 border-black mt-2">
            <div class="col">
                Sep-Jun
            </div>
            <div class="col">
                {{showSerie(courseCurrent?.serieName)}}
            </div>
            <div class="col">
                <a>Diploma</a>
            </div>
        </div>
    </div>

</div>